import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import "./admin.css";

export default function AdminLogin() {
  const { signIn, admin, checking } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!checking && admin) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const res = await signIn(email, password);
    if (!res.ok) setErr(res.error || "Sign-in failed");
    setLoading(false);
  };

  return (
    <div className="adm adm-login" data-testid="admin-login-page">
      <form className="adm-login-card" onSubmit={submit}>
        <div className="adm-brand" style={{ borderBottom: "none", paddingBottom: 0, marginBottom: 18 }}>
          <div className="adm-brand-mark">DC</div>
          <div>
            <div className="adm-login-title">Damage Culture</div>
            <div className="adm-login-sub adm-mono" style={{ letterSpacing: "0.16em", textTransform: "uppercase" }}>Admin</div>
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label className="adm-label">Email</label>
          <input data-testid="admin-login-email" className="adm-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label className="adm-label">Password</label>
          <input data-testid="admin-login-password" className="adm-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
        </div>
        {err && <div data-testid="admin-login-error" style={{ background: "#EF444411", border: "1px solid #EF444433", color: "#FCA5A5", padding: "9px 12px", borderRadius: 8, fontSize: 12.5, marginBottom: 12 }}>{err}</div>}
        <button data-testid="admin-login-submit" className="adm-btn" type="submit" disabled={loading} style={{ width: "100%" }}>
          {loading ? "Signing in..." : "Sign in"}
        </button>
        <p style={{ fontSize: 11.5, color: "#5A5A62", marginTop: 14, fontFamily: "JetBrains Mono, monospace", textAlign: "center" }}>
          INVITE-ONLY. THIS IS THE BACK ROOM.
        </p>
      </form>
    </div>
  );
}
